// 在文件开头添加这些调试代码


// API 配置
export const API_BASE_URL = (() => {
  const configuredUrl = process.env.REACT_APP_API_BASE_URL;
  if (!configuredUrl) {
    console.warn('警告: REACT_APP_API_BASE_URL 未设置，使用默认值');
  }
  return configuredUrl || 'https://bbvxwigtjajz.sealosgzg.site';
})();

// 通用请求配置
export const API_REQUEST_CONFIG = {
  mode: 'cors' as RequestMode,
  credentials: 'include' as RequestCredentials,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
};

// API 端点
export const API_ENDPOINTS = {
  // 邮箱验证相关
  EMAIL: {
    SEND_CODE: `${API_BASE_URL.trim()}/api/email/send-code`,
    VERIFY_CODE: `${API_BASE_URL.trim()}/api/email/verify-code`,
  },
  // 用户认证相关
  AUTH: {
    LOGIN: `${API_BASE_URL.trim()}/auth/login`,
    REGISTER: `${API_BASE_URL.trim()}/auth/register`,
    LOGOUT: `${API_BASE_URL.trim()}/auth/logout`,
    PROFILE: {
      GET: `${API_BASE_URL.trim()}/auth/profile`,
      UPDATE: `${API_BASE_URL.trim()}/auth/profile`,
    },
  },
  // 背调相关
  BACKGROUND_CHECK: {
    CREATE: `${API_BASE_URL.trim()}/api/v2/sales/background-check`,
    LIST: `${API_BASE_URL.trim()}/api/v2/sales/background-checks`,
    EXPORT: `${API_BASE_URL.trim()}/api/v2/sales/background-checks/export`,
  },
  // 地图搜索相关
  MAP: {
    SEARCH: `${API_BASE_URL.trim()}/api/v2/map/search`,
    LOCATIONS_SUGGEST: `${API_BASE_URL.trim()}/api/v2/map/locations/suggest`,
    SEARCH_HISTORY: `${API_BASE_URL.trim()}/api/v2/map/search/history`,
  },
  // 统计相关
  STATS: {
    DAILY_CHECKS: `${API_BASE_URL.trim()}/api/stats/daily-checks`,
  },
  // 笔记相关
  NOTES: {
    LIST: `${API_BASE_URL.trim()}/api/v2/sales/notes`,
    CREATE: `${API_BASE_URL.trim()}/api/v2/sales/notes`,
    DELETE: (id: number) => `${API_BASE_URL.trim()}/api/v2/sales/notes/${id}`,
  },
  // 授权相关
  OIDC: {
    CODE: `${API_BASE_URL.trim()}/auth/oidc/code`,
  },
}; 